import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mb-8" }
const _hoisted_2 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }
const _hoisted_3 = { class: "d-flex flex-wrap gap-3" }
const _hoisted_4 = ["disabled", "onClick"]
const _hoisted_5 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_ctx.input.label), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.input.buttons, (btn, idx) => {
        return (_openBlock(), _createElementBlock("button", {
          key: btn.key || idx,
          type: "button",
          class: "btn btn-sm btn-primary",
          disabled: _ctx.loadingKey === (btn.key || idx),
          onClick: ($event: any) => (_ctx.callEndpoint(btn, btn.key || idx))
        }, [
          (_ctx.loadingKey === (btn.key || idx))
            ? (_openBlock(), _createElementBlock("span", _hoisted_5))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(btn.label), 1)
        ], 8, _hoisted_4))
      }), 128))
    ])
  ]))
}